import React, { useEffect } from "react";

const LABEL = "Is this the controlling or only Ultimate Beneficial Owner?";

const buttonStyle = {
    marginTop: "10px",
    padding: "8px 16px",
    border: "none",
    background: "#07b1b0",
    color: "white",
    borderRadius: "4px",
    cursor: "pointer",
};

const regulatedOrListed = (d) => d.uboRegulatory === "Yes" || d.uboRecognisedExchange === "Yes";

// Per UBO type: when is this UBO regulated (same idea as Client/Counterparty's
// regulated OR listed on a recognised exchange)? Questions about someone else
// (fund manager, trustee, administrator) deliberately don't count.
const TRIGGERS = {
    "Private Company": regulatedOrListed,
    "Partnership": regulatedOrListed,
    "Company Listed on a Recognised Stock Exchange": regulatedOrListed,
    "Regulated Entity": () => true,
    // MLR 2017 reg. 37: public administrations / publicly owned enterprises are lower risk.
    "Public Sector Bodies, governments, state owned companies and local authorities.": () => true,
    "Pension Fund": (d) => d.uboIsPensionFundRegistered === "Yes",
    "Fund": (d) => d.uboRegulatedFund === "Yes",
};

// A Yes in the popup below (plus no Enhanced anywhere) makes the request Simplified
// on save, see applyUboSimplified in CorporateStructure.
export const isUboSimplifiedTrigger = (type, data = {}) => !!TRIGGERS[type]?.(data || {});

// Every country a UBO mentions (incorporation, establishment, nationality, trustee,
// nominee...). Field names differ per UBO type, so match on the key.
// ponytail: key-name match; if a non-country field ever contains "country", tighten it.
export const uboCountries = (ubos = []) => {
    const found = new Set();
    for (const u of ubos) {
        for (const [key, value] of Object.entries(u?.data || {})) {
            if (/country|nationality/i.test(key) && typeof value === "string" && value && value !== "None") {
                found.add(value);
            }
        }
    }
    return [...found];
};

// Popup only, there is no field in the form. It stays open until answered whenever a
// trigger is on and there is no answer yet: a regulated question flips to Yes, the
// Regulated Entity / Public Sector type is picked, or a UBO saved before this question
// existed is opened. To change the answer, set the trigger to No and back to Yes.
export const ControllingUboQuestion = ({ renderBy, uboType, formData = {}, onChange, isReadOnly, isReport }) => {
    const triggered = isUboSimplifiedTrigger(uboType, formData);

    // Drop a stale answer once the trigger is off, so it can't simplify later.
    useEffect(() => {
        if (!triggered && formData.uboControllingOwner) {
            onChange({ target: { name: "uboControllingOwner", value: "" } });
        }
    }, [triggered, formData.uboControllingOwner, onChange]);

    // UBO only (Management Structure reuses these forms), and never in view/report mode.
    if (renderBy !== "corporate" || !triggered || formData.uboControllingOwner || isReadOnly || isReport) return null;

    const answer = (value) => onChange({ target: { name: "uboControllingOwner", value } });

    return (
        <div className="modal" style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0, 0, 0, 0.5)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 10 }}>
            <div className="modal-content" style={{ background: "white", padding: "20px", borderRadius: "8px", textAlign: "center", maxWidth: "500px" }}>
                <p style={{ textAlign: "left", fontWeight: "bold" }}>{LABEL}</p>
                <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                    <button type="button" style={buttonStyle} onClick={() => answer("Yes")}>Yes</button>
                    <button type="button" style={buttonStyle} onClick={() => answer("No")}>No</button>
                </div>
            </div>
        </div>
    );
};
